<template>
  <w-sliding-popup ref="slidingPopup" title="자원 설정" width="1200px" :default-content="false" @close="close">
    <div slot="content" class="body-content-no-scroll" style="height:100%;">
      <!-- 물리 테이블 -->
      <div style="height: 100%; width: 500px; margin-right:20px; float:left;">
        <w-setting-target-obj-tree ref="settingTargetObjTree" :obj-view-type="objViewType" @setSelectedNode="setSelectedNode"></w-setting-target-obj-tree>
      </div>
      <!-- 자원 설정 -->
      <div style="height: 100%; width:calc(100% - 520px); float:right;">
        <el-row class="title-bar" type="flex" justify="space-between">
          <div>
            <span class="title-h4">{{rscSettingTitle}}</span>
          </div>
          <div>
            <el-button size="mini" type="primary" :disabled="isDisabledSave" @click="savePredictInfo">저장</el-button>
            <el-button size="mini" :disabled="isDisabledSave" @click="revertRscTableInfo">취소</el-button>
            <w-header-search-button size="mini" @click="rscShowSearchTool = !rscShowSearchTool"></w-header-search-button>
          </div>
        </el-row>
        <!-- 자원 테이블 -->
        <el-table-wrapper style="height:calc(100% - 41px);" :data="targetPredictTableData" :columns="targetPredictTableColumn" ref="predictTable"
          @select="targetSelectionChange" @select-all="checkSelectionAll" :total="total" :pagination="true"
          :fit-height="true" :show-search-tool="rscShowSearchTool" :show-custom-header="true" @condition-change="reload">
        </el-table-wrapper>
      </div>
    </div>
  </w-sliding-popup>
</template>

<script>
import moment from 'moment';
import { removeTime } from '@/utils/date';
import { isNil, isEmpty, cloneDeep, findIndex, find } from 'lodash';
import EventRptApi from '@/api/event/event-rpt';
import msgUtil from '@/utils/message';
import WSettingTargetObjTree from '@/views/settings/operation/BasicInfoSettings/EventPredictSetting/components/SettingTargetObjTree';

export default {
  name: 'WPredictAnalysisRscSettingPopup',
  components: {
    WSettingTargetObjTree,
  },
  data() {
    return {
      total: null,
      rscShowSearchTool: false,
      isDisabledSave: true,
      objViewType: null,
      originCheckList: [],
      selectedObj: null,
      originTableData: [],
      targetPredictTableData: [],
      predictRscList: {},
      selectionList: [],
      targetPredictTableColumn: [
        {
          type: 'selection',
        },
        {
          prop: 'rsctypeName',
          label: '자원 구분',
          headerAlign: 'center',
          remoteProp: 'rt.rsctype_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'rscName',
          label: '자원',
          headerAlign: 'center',
          remoteProp: 'r.rsc_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'rscKey',
          label: '자원키',
          headerAlign: 'center',
          remoteProp: 'ork.rsc_key',
          width: 100,
          sortable: true,
          searchable: true,
        },
      ],
    };
  },
  computed: {
    /**
     * 예측 자원 설정 타이틀
     */
    rscSettingTitle() {
      const title = '장애 예측 분석 자원';
      return isNil(this.selectedObj) ? title : `[${this.selectedObj.objName}] ${title}`;
    },
  },
  watch: {
    selectedObj: {
      handler(to) {
        if (!isEmpty(to)) {
          this.reload();
        }
      },
      immediate: true,
    },
  },
  methods: {
    open(row) {
      this.$refs.slidingPopup.open();
      this.predictRscList = row;
    },
    close() {
      this.$refs.slidingPopup.visible = false;
    },
    /**
     * 트리 컴포넌트에서 선택한 obj를 받아온다.
     */
    setSelectedNode(objNode) {
      this.originCheckList = [];
      this.selectedObj = objNode;
    },
    /**
     * 장애 예측 분석 자원을 조회한다.
     * @author Song
     */
    loadPredictAnalysisRscInfo() {
      this.selectionList = [];
      this.originCheckList = [];
      const tableParams = this.$refs.predictTable.getParameter();
      const params = {
        objId: this.selectedObj.objId,
        ...tableParams,
      };
      EventRptApi.getPredictTargetRscList(params).then((res) => {
        if (res.data.success) {
          this.originTableData = cloneDeep(res.data.data);
          this.targetPredictTableData = res.data.data;
          this.total = res.data.total;
          // 조회된 목록 중 이미 등록된 자원일 경우 check 표시
          this.$nextTick(() => {
            this.targetPredictTableData.forEach((item) => {
              if (item.ltpdFlag === 1) {
                this.originCheckList.push(item);
                this.selectionList.push(item);
                this.$refs.predictTable.$children[0].toggleRowSelection(item);
              }
              if (isEmpty(this.selectionList)) {
                this.isDisabledSave = true;
              }
            });
          });
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '장애 예측 분석 자원 목록', false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '장애 예측 분석 자원 목록', false));
      });
    },
    /**
     * 설정한 예측 분석 자원 저장, 수정(삭제)
     * @author Song
     */
    savePredictInfo() {
      const insertListTemp = []; // 가공전
      const insertList = []; // insert 파라미터
      const deleteList = [];
      let addedWeekCount = 6 - moment(new Date()).day();
      // 토요일의 경우 일주일 추가
      if (addedWeekCount === 0) {
        addedWeekCount += 1;
      }
      // 현재 시간 기준 다음 스케줄링 시간 (predict_datetime)
      const predictDatetime = moment(removeTime(moment(new Date()))).add(addedWeekCount, 'days').add(this.hour, 'hours').add(this.minute, 'minutes')
        .toDate();
      // 추가 목록
      this.selectionList.forEach((item) => {
        const findChange = find(this.originTableData, (originInfo) => originInfo.hashkeyIdString === item.hashkeyIdString);
        if (findChange) {
          if (!findChange.ltpdFlag) {
            insertListTemp.push(item);
          }
        }
      });
      // 삭제 목록
      this.originTableData.forEach((item) => {
        const findChange = find(this.targetPredictTableData, (selectInfo) => selectInfo.hashkeyIdString === item.hashkeyIdString);
        if (item.ltpdFlag && !findChange.ltpdFlag) {
          deleteList.push(item);
        }
      });
      if (!isEmpty(this.predictRscList)) {
        // 이미 설정된 예측 분석 자원이 있다면 해당 learn 데이터 사용
        const rowData = this.predictRscList;
        insertListTemp.forEach((item) => {
          const tempJson = {
            predictDatetime: rowData.predictDatetime,
            hashkeyId: item.hashkeyIdString,
            learnDataSet: rowData.learnDataSet,
            learnDataSetRaw: rowData.learnDataSetRaw,
            learnDataSetLabel: rowData.learnDataSetLabel,
            eventRptPredictFlag: 'Y',
            scheduleRepeatFlag: rowData.scheduleRepeatFlag,
          };
          insertList.push(tempJson);
        });
      } else {
        // 아직 등록된 예측 분석 자원이 하나도 없는 경우
        // eventRptPredictFlag: 'Y', scheduleRepeatFlag: 'N' (스케줄 x), predict_datetime은 기존 방식
        // learn_data_set, learn_data_set_raw, learn_data_set_label은 null 넘겨준다. (추후 스케줄 설정시 업데이트 된다.)
        insertListTemp.forEach((item) => {
          const tempJson = {
            predictDatetime,
            hashkeyId: item.hashkeyIdString,
            eventRptPredictFlag: 'Y',
            scheduleRepeatFlag: 'N',
          };
          insertList.push(tempJson);
        });
      }
      const params = {
        insertList,
        deleteList,
      };
      // 예측 분석 자원 수정 api
      EventRptApi.setPredictAnalysisRscList(params).then((res) => {
        if (res.data.success) {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '예측 분석 자원', true));
          this.reload();
          this.isDisabledSave = true;
          this.$emit('reload');
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '예측 분석 자원', false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '예측 분석 자원', false));
      });
    },
    /**
     * 설정한 예측 분석 자원 revert
     */
    revertRscTableInfo() {
      this.originCheckList = [];
      this.selectionList = [];
      this.isDisabledSave = true;
      this.targetPredictTableData = cloneDeep(this.originTableData);
      this.$nextTick(() => {
        this.targetPredictTableData.forEach((item) => {
          if (item.ltpdFlag === 1) {
            this.originCheckList.push(item);
            this.$refs.predictTable.$children[0].toggleRowSelection(item);
          }
        });
      });
    },
    /**
     * 선택한 이벤트 예측 자원을 리스트에 설정
     * 해당 관리대상에서 조회된 자원 중 이미 선택된 자원들은 체크처리
     * @author Song
     */
    targetSelectionChange(rows, row) {
      let changeFlag = true;
      const targetTableData = this.targetPredictTableData;
      const toggleCheckData = findIndex(targetTableData, (item) => row.hashkeyIdString === item.hashkeyIdString);
      targetTableData[toggleCheckData].ltpdFlag = row.ltpdFlag ? 0 : 1;
      if (this.originCheckList.length !== rows.length) {
        changeFlag = false;
      } else {
        rows.forEach((targetItem) => {
          const findChange = find(this.originCheckList, (originInfo) => originInfo.hashkeyIdString === targetItem.hashkeyIdString);
          if ((findChange.ltpdFlag !== targetItem.ltpdFlag)) {
            changeFlag = false;
          }
        });
      }
      this.selectionList = rows;
      this.isDisabledSave = changeFlag;
    },
    /**
     * 체크박스 전체 선택 이벤트
     * @author Song
     */
    checkSelectionAll(selection) {
      const allSelectionList = cloneDeep(selection);
      const targetTableData = this.targetPredictTableData;

      this.$nextTick(() => {
        // 전체 선택이 해제된 경우
        if (isEmpty(selection)) {
          targetTableData.forEach((item) => {
            if (item.ltpdFlag) {
              item.ltpdFlag = !(item.ltpdFlag);
            }
          });
          // 기존값 또한 비어있는 경우 disabled true
          if (isEmpty(this.selectionList)) {
            this.isDisabledSave = true;
          } else {
            this.isDisabledSave = false;
          }
          this.selectionList = [];
        } else {
          // 전체 선택
          allSelectionList.forEach((selectionInfo) => {
            const toggleCheckData = findIndex(targetTableData, (item) => selectionInfo.hashkeyIdString === item.hashkeyIdString);
            if (!(targetTableData[toggleCheckData].ltpdFlag)) {
              targetTableData[toggleCheckData].ltpdFlag = !(targetTableData[toggleCheckData].ltpdFlag);
            }
          });
          this.isDisabledSave = false;
          this.selectionList = selection;
        }
        this.targetPredictTableData = targetTableData;
        this.selectionList = isEmpty(selection) ? [] : selection;
      });
    },
    /**
     * 설정 후 재로드를 위한 reload 함수
     */
    reload() {
      if (!isNil(this.$refs.predictTable)) {
        this.isDisabledSave = true;
        this.loadPredictAnalysisRscInfo();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.list-info {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    min-height: 50px;
    border: 1px solid #e9e9e9;
    background-color: #f1f1f1;
    // margin-bottom: 10px;
    padding: 4px 18px;

    & > .select {
        padding: 4px 0;
    }
    .select > .tit {
        padding-right: 10px;
        font-size: 14px;
        letter-spacing: -1px;
    }

    .custom-input {
        margin-left: 4px;

        &:first-child {
            margin-left: 0;
        }
    }

    .lists {
        display: inline-block;
        align-items: center;
        padding: 5px 0;

        & > li {
            margin-right: 10px;
            //padding-left: 10px;
            // background: url($url + 'dot.png') no-repeat 0 5px;
            font-weight: 500;
            display: inline;
            width: 40%;

            &:first-child {
                //margin-left: 0;
                //padding-left: 0;
            }
        }
        & > li > .tit {
            display: inline-block;
            padding-right: 4px;
            font-size: 13px;
            letter-spacing: -1px;
        }
        .high {
            color: #1c768d;
            margin-right: 6px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/event/components/popup/PredictAnalysisRscSettingPopup.vue